import { DateTime } from 'luxon';

export const getDeliveryTime = timestamp =>
  DateTime.fromMillis(parseInt(timestamp)).toFormat('yyyy-MM-dd');
